<div echarts [options]="options" [initOpts]="{ renderer: 'svg' }" [ngStyle]="{width: size[0]+'px', height: size[1]+'px'}" class="customer-chart"></div>
